// extracted by mini-css-extract-plugin
module.exports = {"content":"UnassignmentEvent_content__2G9dK","fullWidth":"UnassignmentEvent_fullWidth__1DcHI","compact":"UnassignmentEvent_compact__2g08m"};